import { useFormikContext } from 'formik'
import * as MotionElement from '~/components/ui/MotionElement'
import { PartnerContact, SectionHeading, EmptyState } from '~/components'
import * as common from '~/config/common.module.css'
import { useTranslation } from 'react-i18next'

export default function PartnerSelection({ providers, sectionNumber = 2, error = false, headingRef }) {
  const { t } = useTranslation()
  const { values, setFieldValue } = useFormikContext()

  const onSelect = (providerId) => {
    setFieldValue('selectedProviderId', providerId, false)
  }

  const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm'

  return (
    <MotionElement.div className={common.group}>
      <SectionHeading number={sectionNumber} title={t('header-select-partner')} error={error} innerRef={headingRef} />
      {providers.length === 0 ? (
        <EmptyState
          icon={<img src={`/app/themes/${theme}/static/img/logo-allians.png`} alt="" className="size-8 object-contain" />}
          title={t('header-no-providers-found')}
          description={t('info-no-providers-found')}
        />
      ) : (
        providers.map((provider) => {
          const { providerId, name } = provider.providerData
          const effectiveServiceType = values.serviceType === 'estate' ? 'taxi' : values.serviceType
          const availability = provider.availabilities?.find(a => a.serviceType === effectiveServiceType)
          const waitTime = availability?.expectedWaitTime
          const priceEntry = values.serviceType
            ? values.priceEstimate?.prices?.find(p => p.providerId === providerId && p.serviceType === effectiveServiceType)
            : null

          const originalPrice = priceEntry && priceEntry.fullPrice !== priceEntry.finalPrice
            ? `${priceEntry.fullPrice}:-`
            : undefined

          return (
            <PartnerContact
              key={providerId}
              type="option"
              providerId={providerId}
              name={name}
              subtitle={waitTime != null ? `${waitTime} min` : undefined}
              price={priceEntry ? `${priceEntry.finalPrice}:-` : undefined}
              originalPrice={originalPrice}
              selected={values.selectedProviderId === providerId}
              priceLoading={values.priceIsLoading}
              onClick={() => onSelect(providerId)}
            />
          )
        })
      )}
    </MotionElement.div>
  )
}
